import { render, staticRenderFns } from "./StModal.vue?vue&type=template&id=c13a0e04"
import script from "./StModal.vue?vue&type=script&lang=js"
export * from "./StModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports